import React, { useMemo } from 'react';

// DEPENDENCIES
import { useLocation } from 'react-router-dom';
import { useRecordContext } from 'helpers/getRecordData';

// GLOBAL VARIABLES
import { INVENTORY_STATUS } from 'codes.js';
import { INTERFACE, RECORD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';

// MAIN COMPONENT
const AddSaleButton = () => {

  // REACT ROUTER
  const location = useLocation();

  // HOOKS
  const { record: { inventory_status_code } = {}, recordID } = useRecordContext() || {};

  // MEMOS
  const buttonProps = useMemo(
    () => ({
      to: {
        pathname: makePath(INTERFACE.sales, RECORD.add, recordID),
        state: { prevPath: location.pathname }
      },
      disabled: !![INVENTORY_STATUS.order.code, INVENTORY_STATUS.sold.code, INVENTORY_STATUS.delivered.code, INVENTORY_STATUS.returned.code].includes(inventory_status_code)
    }),
    [recordID, inventory_status_code, location]
  )

  // RENDER
  return (
    <Button
      variant="success"
      label="Add Sale"
      icon="add-circle"
      size="sm"
      fullWidth={false}
      {...buttonProps}
    />
  )
}

// EXPORT
export default AddSaleButton;
